import React from "react"
import { Link } from "react-router-dom"

function Success() {
    return (
        <div className="container mt-5 text-center">
            <div className="card p-4 shadow-sm" style={{ maxWidth: '500px', margin: '0 auto' }}>
                <h2 className="text-success mb-4">🎉 Booking Successful!</h2>
                <p className="lead mb-4">Your booking has been saved successfully. We look forward to serving you!</p>
                <Link to="/" className="btn btn-primary">
                    Return to Home
                </Link>
            </div>
        </div>
    )
}

export default Success